/** @jsxImportSource @emotion/react */

import { FC, useMemo } from "react";
import Dashboard from "..";
import { Services } from "../../../graphql/__GENERATED__/types";
import {
  ToDocumentDetailsLocation,
  ToSimulationLocation,
} from "../../../Locations";
import { documentCards } from "../components/Cards/assets/dashboardCards";
import DocumentDashboardCard from "../components/Cards/components/DocumentDashboardCard";
import { IconNames } from "../../../components/Icons/styles/iconNames";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import { useFlags } from "../../../hooks/useFlags";

const DocumentsDashboard: FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { isFlagEnabled } = useFlags();

  const handleShareProviderLink = () => {
    const { protocol, host } = window.location;
    const shareLink = `${protocol}//${host}/${user.username}`;
    navigator.clipboard.writeText(shareLink);
    alert(`Link copiado: ${shareLink}`);
  };
  const handleNewSimulation = () => {
    navigate(ToSimulationLocation("new", "simulacao"));
  };

  const documentsActions = useMemo(() => {
    if (!isFlagEnabled("admin-only")) return;
    return [
      {
        text: "Nova Cotação",
        iconName: IconNames.Add,
        onClick: handleNewSimulation,
      },
      {
        text: "Link",
        iconName: IconNames.Share,
        onClick: handleShareProviderLink,
      },
    ];
  }, [isFlagEnabled]);

  return (
    <Dashboard
      serviceName={Services.Documents}
      redirectLocation={ToDocumentDetailsLocation}
      cards={documentCards}
      CardComponent={DocumentDashboardCard}
      dashboardActions={documentsActions}
    />
  );
};

export default DocumentsDashboard;
